
import { defineMessages } from 'react-intl';
const defaultMessages = defineMessages(
  {
    "billingPlansAnsweringTitle": {
      "id": "billing_plans.answering_title",
      "defaultMessage": "Popmenu AI Answering"
    },
    "billingPlansLearnMoreAnswering": {
      "id": "billing_plans.learn_more_answering",
      "defaultMessage": "Start a conversation with us"
    },
    "billingPlansRequestUpgrade": {
      "id": "billing_plans.request_upgrade",
      "defaultMessage": "Request Upgrade"
    },
    "billingPlansRequestUpgradeRestricted": {
      "id": "billing_plans.request_upgrade_restricted",
      "defaultMessage": "Contact your Admin to upgrade"
    },
    "billingPlansRequestUpgradeSubmitted": {
      "id": "billing_plans.request_upgrade_submitted",
      "defaultMessage": "Request Submitted"
    },
    "billingPlansUpgradePlans": {
      "id": "billing_plans.upgrade_plans",
      "defaultMessage": "Upgrade Plans"
    }
  }
);
export default defaultMessages;
